import { Button } from '@diamond-design/components';
import styles from './ctaButton.module.scss';

export default function CtaButton({
  className,
  color = '',
  variant = '',
  textTransform = false,
  defaultColor = false,
  ...props
}) {
  const variantMapping = {
    solid: 'primary',
    link: 'link',
    default: 'secondary',
  };

  const buttonVariant =
    variantMapping[variant?.toLowerCase()] || variantMapping.default;

  const isPrimary = buttonVariant?.toLowerCase() === 'primary';

  const colorMapping = {
    red: isPrimary ? styles.redPrimary : styles.redSecondary,
    'light blue': isPrimary
      ? styles.lightBluePrimary
      : styles.lightBlueSecondary,
    default: isPrimary ? styles.trueBluePrimary : styles.trueBlueSecondary,
  };

  const buttonColor =
    colorMapping[color?.toLowerCase()] || colorMapping.default;

  let variantClass = '';

  if (buttonVariant === 'link') {
    variantClass = styles.link;
  } else if (!defaultColor) {
    variantClass = buttonColor;
  }

  return (
    <Button
      className={`${className} ${
        textTransform ? styles.textTransform : ''
      } ${variantClass} ${
        !isPrimary && !defaultColor ? styles.backgroundTransparent : ''
      } ${styles.button}`}
      variant={buttonVariant}
      color={defaultColor}
      {...props}
    />
  );
}
